import type { ReactNode } from 'react';
import { Link, Outlet } from 'react-router';
import { Logo } from '@growhero/brand';
import { cn } from '@/lib/cn';
import { LanguageToggle, ThemeToggle } from '../shell/UserBar';

/** Minimal chrome for setup/onboarding and public token pages. */
export function CenteredLayout({
  children,
  width = 'max-w-2xl',
  right,
  homeLink = '/',
}: {
  children?: ReactNode;
  width?: string;
  right?: ReactNode;
  homeLink?: string | null;
}) {
  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      <header className="flex items-center justify-between px-5 py-5 sm:px-8">
        {homeLink ? (
          <Link
            to={homeLink}
            aria-label="GrowHero"
            className="rounded-sm focus-visible:outline-2 focus-visible:outline-focus"
          >
            <Logo height={26} title="GrowHero" />
          </Link>
        ) : (
          <Logo height={26} title="GrowHero" />
        )}
        <div className="flex items-center gap-1">
          {right}
          <LanguageToggle />
          <ThemeToggle />
        </div>
      </header>
      <main className={cn('mx-auto w-full flex-1 px-5 pb-16 pt-6 sm:px-8 sm:pt-10', width)}>
        {children ?? <Outlet />}
      </main>
    </div>
  );
}

/** Public pages customers see (review links, unsubscribe): no app chrome, business-first. */
export function PublicLayout() {
  return (
    <div className="min-h-dvh bg-canvas">
      <main className="mx-auto w-full max-w-lg px-5 py-10">
        <Outlet />
      </main>
    </div>
  );
}
